<template>
  <div id="app">
    <!-- 路由的出入口，路由的内容将被显示在这里 -->
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  mounted () {
    this.refreshScale()
    window.addEventListener('resize', () => {
      this.refreshScale()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.refreshScale)
  },
  methods: {
    refreshScale () {
      // let baseWidth = document.documentElement.clientWidth
      // let baseHeight = document.documentElement.clientHeight
      // let appStyle = document.querySelector('#app').style
      // let realRatio = baseWidth / baseHeight
      // // let designRatio = 16 / 9
      // let scaleRate = baseWidth / 1920
      // // if (realRatio > designRatio) {
      // //   scaleRate = baseHeight / 1080
      // // }
      // appStyle.transformOrigin = 'left top'
      // appStyle.transform = `scale(${scaleRate})`
      // // appStyle.width = `${baseWidth / scaleRate}px`
    }
  },
  created () {
    (function () {
      var meta = document.createElement("meta");
      var width = window.screen.width;
      var targetWidth = 1920;
      var scale = width / targetWidth;
      meta.name = "viewport";
      meta.content = "width=device-width,initial-scale=" + scale + ",minimum-scale=" + scale + ",maximum-scale=1,user-scalable=yes,target-densitydpi=" + width;
      document.head.appendChild(meta);
    })();

    function windowHeight () {
      var de = document.documentElement;
      return self.innerHeight || (de && de.clientHeight) || document.body.clientHeight;
    }
    window.onload = window.onresize = function () {
      var wh = windowHeight();
    }
  },
}
</script>
<style>
body {
  margin: 0;
  padding: 0;
  border: 0;
  /*min-width: 1320px;*/
  /*overflow: auto;*/
  font-size: 14px;
}
#app {
  /*width: 100vw;*/
  /* height: 1080px; */
}
/* html {
  min-width: 1320px;
} */
/** 防止页面因为滚动条抖动 */
/* html { */
/*overflow-y: scroll;*/
/* } */
/* :root { */
/*overflow-y: auto;*/
/*overflow-x: hidden;*/
/* } */
/* :root body { */
/*position: absolute;*/
/* } */
/* body { */
/*width: 100vw;*/
/*overflow: hidden;*/
/* } */
</style>
